import { gql } from "@urql/core";

export const REQUEST_TEMPLATE_LIST_QUERY = gql`
  query PurchaseTemplateList($query: RefineQueryInput) {
    purchaseTemplates(query: $query) {
      nodes {
        id
        name
        templateKind
        teamId
        fiscalYear
        isActive
        approvalType
        externalWorkflow
        createdAt
        updatedAt
      }
    }
  }
`;

export const REQUEST_TEMPLATE_ONE_QUERY = gql`
  query PurchaseTemplateOne($id: String!) {
    purchaseTemplate(id: $id) {
      id
      name
      templateKind
      teamId
      fiscalYear
      isActive
      approvalType
      externalWorkflow
      createdAt
      updatedAt
    }
  }
`;

export const ACTIVE_REQUEST_TEMPLATE_QUERY = gql`
  query ActivePurchaseTemplate($templateKind: PurchaseTemplateKind, $teamId: String, $fiscalYear: Float) {
    activePurchaseTemplate(templateKind: $templateKind, teamId: $teamId, fiscalYear: $fiscalYear) {
      id
      name
      templateKind
      teamId
      fiscalYear
      isActive
      approvalType
      externalWorkflow
    }
  }
`;

export const CREATE_REQUEST_TEMPLATE_MUTATION = gql`
  mutation CreatePurchaseTemplate($input: CreatePurchaseTemplateInput!) {
    createPurchaseTemplate(input: $input) {
      id
      name
      templateKind
      teamId
      fiscalYear
      isActive
      approvalType
      externalWorkflow
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_REQUEST_TEMPLATE_MUTATION = gql`
  mutation UpdatePurchaseTemplate($id: String!, $input: UpdatePurchaseTemplateInput!) {
    updatePurchaseTemplate(id: $id, input: $input) {
      id
      name
      templateKind
      teamId
      fiscalYear
      isActive
      approvalType
      externalWorkflow
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_REQUEST_TEMPLATE_MUTATION = gql`
  mutation DeletePurchaseTemplate($id: String!) {
    deletePurchaseTemplate(id: $id) {
      id
    }
  }
`;
